import { ArdoqId } from '@ardoq/api-types';
import { PermissionContext } from './types';
import { canDo } from './canDo';
import { permissionsOperations } from './permissionsOperations';

// This file contains functions that wrap canDo for specific resource types in
// order to give people a more intuitive API when checking permissions.  Note
// that these ONLY check resource permissions and do not consider confidential
// fields, nor any app-state logic such as presentation mode or scenario mode.

export const canCreateWorkspace = (permissionContext: PermissionContext) => {
  if (!permissionsOperations.isLoadedPermissionContext(permissionContext)) {
    return false;
  }

  return canDo({
    permissionContext,
    action: 'organization/create_workspace',
    resourceId: permissionsOperations.getOrgIdFromContext(permissionContext),
  });
};

export const canManageGlobalFields = (
  permissionContext: PermissionContext
): boolean => {
  if (!permissionsOperations.isLoadedPermissionContext(permissionContext)) {
    return false;
  }

  return canDo({
    permissionContext,
    action: 'organization/manage_global_fields',
    resourceId: permissionsOperations.getOrgIdFromContext(permissionContext),
  });
};

export const canAdminWorkspace = (
  permissionContext: PermissionContext,
  workspaceId: ArdoqId
) =>
  canDo({
    permissionContext,
    resourceId: workspaceId,
    action: 'workspace/admin',
  });

export const canEditWorkspace = (
  permissionContext: PermissionContext,
  workspaceId: ArdoqId
) =>
  canDo({
    permissionContext,
    resourceId: workspaceId,
    action: 'workspace/edit',
  });

export const canAccessWorkspace = (
  permissionContext: PermissionContext,
  workspaceId: ArdoqId
) =>
  canDo({
    permissionContext,
    resourceId: workspaceId,
    action: 'workspace/read',
  });

export const canCreateTraversal = permissionsOperations.hasWriterRolePlus;

export const canAdminTraversal = (
  permissionContext: PermissionContext,
  traversalId: ArdoqId
): boolean =>
  canDo({
    permissionContext,
    action: 'traversal/admin',
    resourceId: traversalId,
  });

export const canEditTraversal = (
  permissionContext: PermissionContext,
  traversalId: ArdoqId
): boolean =>
  canDo({
    permissionContext,
    action: 'traversal/edit',
    resourceId: traversalId,
  });

export const canAccessTraversal = (
  permissionContext: PermissionContext,
  traversalId: ArdoqId
): boolean =>
  canDo({
    permissionContext,
    action: 'traversal/read',
    resourceId: traversalId,
  });
